import React from 'react'
import { CheckCircleFilled, LoginOutlined, LogoutOutlined, SyncOutlined, WarningFilled } from '@ant-design/icons'
import LoadingIcon from '../assets/CustomIcons/orderStatusIcons/loading-icon.svg'
import DroppingIcon from '../assets/CustomIcons/orderStatusIcons/dropping-icon.svg'
import { IconClockPause, IconClockStop } from '@tabler/icons-react'

export const updateTypes = {
  login: 'Login',
  driver_pre_trip: 'Pre Trip',
  trip_update: 'Trip Update',
  save_order_location_bols: 'Save BOLs',
  save_bol: 'Save BOL',
  save_drop: 'Save Drop',
  driver_post_trip: 'Post Trip',
  logout: 'Logout',
  load_volume_override: 'Load Volume Override',
  load_supplier_override: 'Load Supplier Override',
  driver_delay: 'Driver Delay',
  driver_break: 'Driver Break',
  wrong_location_warning: 'Wrong Location',
}

export const updateTypeIcons = {
  login: <LoginOutlined />,
  driver_pre_trip: <CheckCircleFilled />,
  trip_update: <SyncOutlined />,
  save_order_location_bols: <img src={LoadingIcon} />,
  save_bol: <img src={LoadingIcon} />,
  save_drop: <img src={DroppingIcon} />,
  logout: <LogoutOutlined />,
  driver_post_trip: <CheckCircleFilled />,
  load_volume_override: <CheckCircleFilled />,
  load_supplier_override: <CheckCircleFilled />,
  driver_delay: <IconClockStop />,
  driver_break: <IconClockPause />,
  wrong_location_warning: <WarningFilled />,
}

export const typeAppearance = {
  login: 'default',
  driver_pre_trip: 'primary',
  trip_update: 'medium',
  save_bol: 'secondary',
  save_order_location_bols: 'secondary',
  save_drop: 'theme3',
  driver_post_trip: 'success',
  logout: 'hint',
  load_volume_override: 'default',
  load_supplier_override: 'default',
  driver_delay: 'error',
  driver_break: 'default',
  wrong_location_warning: 'warning',
}
